import React from "react";
import { Classification, Locale, Participant } from "../../core/api/model";
import { DashboardClassificationsList, DashboardClassificationsListAdd } from "../DashboardClassificationsList";
import { DashboardPanel, DashboardPanelItem } from "../DashboardPanel";
import { FormattedMessage, useIntl } from "react-intl";
import { Box, Button } from "@material-ui/core";
import CustomIcon from "../../core/custom-icon";

export interface DashboardClassificationsPanelProps {
  locale: Locale;
  classifications: Classification[];
  classificationsAll: Classification[];
  experts: Participant[];
  addClassification: (classificationId: number, partId: number) => void;
  deleteClassification: (classificationId: number,) => void;
  editClassification: (classificationId: number, partId: number | undefined) => void;
}

export const DashboardClassificationsPanel = (props: DashboardClassificationsPanelProps) => {
  const [addOpen, setAddOpen] = React.useState<boolean>(false);

  const onAddCancel = () => {
    setAddOpen(false);
  }

  const onAddConfirm = (classificationId: number, partId: number) => {
    props.addClassification(classificationId, partId);
    setAddOpen(false);
  }

  const intl = useIntl();

  return (
    <DashboardPanel
      title={intl.formatMessage({id: 'DashboardClassificationsTitle'})}
      addPanel={
        <Box width={{xs: '100%', md: 6/12}}
             mr={{xs: 1.5, md: 2}}
             position='relative'
        >
          {addOpen ? (
              <DashboardClassificationsListAdd
                locale={props.locale}
                classifications={props.classificationsAll
                  // remove classifications that are already linked with corporation
                  .filter((classificationAll: Classification) => {
                      return props.classifications.findIndex((classification: Classification) => {
                        return classificationAll.classificationId === classification.classificationId;
                      }) === -1
                    }
                  )
                }
                experts={props.experts}
                confirm={onAddConfirm}
                cancel={onAddCancel}
              />
            ) : (
            <Box position='absolute'
                 top={0}
                 right={0}
            >
              <Button onClick={() => setAddOpen(true)}
                      color='secondary'
                      endIcon={
                        <CustomIcon iconname='add' />
                      }
              >
                <FormattedMessage id='DashboardClassificationsAdd' />
              </Button>
            </Box>
            )}
        </Box>
      }
    >
      <DashboardPanelItem tabtitle=''>
        <DashboardClassificationsList
          locale={props.locale}
          classifications={props.classifications.slice().sort((a: Classification, b: Classification) => ( a.classificationTitle[props.locale] < b.classificationTitle[props.locale] ? -1 : 1 ))}
          classificationsAll={props.classificationsAll.slice().sort((a: Classification, b: Classification) => ( a.classificationTitle[props.locale] < b.classificationTitle[props.locale] ? -1 : 1 ))}
          experts={props.experts}
          deleteClassification={props.deleteClassification}
          editClassification={props.editClassification}
        />
      </DashboardPanelItem>
    </DashboardPanel>
  )
};
